import { useState } from "react";

// images
import CapsLockIconImage from "../../images/components/input/capslock-icon.svg";
import CancelIconImage from "../../images/components/input/cancel-icon.svg";
import ShowPWIconImage from "../../images/components/input/show-pw-icon.svg";
import HiddenPWIconImage from "../../images/components/input/hidden-pw-icon.svg";


function CommonInput({
    type,
    legend="",
    placeholder,
    handleInput,
    input,
    description="",
    checkvalid=false,
    validation=true,
    existEmail=false
}) {
    const [capslock, setCapslock] = useState(false);
    const [showPW, setShowPW] = useState(false);

    // CapsLock 키 감지
    const handleCapsLock = (curCapsLock) => {
        if(capslock[type]!==curCapsLock){
            setCapslock(curCapsLock)
        }
    }

    return (
        <fieldset className="InputField">
            {legend && <legend>{legend}</legend>}
            <div className="InputWrapper">
                <input
                    type={showPW || type==="name" ? "text" : type}
                    className={`${checkvalid && input[type] ? ((!validation || existEmail) ? "Invalid" : "Valid") : ""}`}
                    placeholder={placeholder}
                    onChange={(e)=>handleInput(e.target.value, type)}
                    onKeyDown={(e)=>handleCapsLock(e.getModifierState("CapsLock"))}
                    onBlur={()=>handleCapsLock(false)}
                    value={input[type]}
                />
                {description &&
                    <div className={`Description ${(!validation && input[type]) ? "Invalid" : ""}`}>
                        {description}
                    </div>}
                {((type==="email" && !validation && input[type]) || existEmail) &&
                    <div className="Validation">
                        {existEmail ? "The email is already in use." : "Invalid email."}
                    </div>
                }
                <div className="InputOption">
                    {input[type]!=="" &&
                        <button
                            type="button"
                            onClick={()=>handleInput("",type)}
                        >
                            <img src={CancelIconImage} alt="cancel icon" />
                        </button>
                    }
                    {input[type]!=="" && type==="password" &&
                        <button
                            type="button"
                            onClick={()=>setShowPW(!showPW)}
                        >
                            <img src={showPW ? HiddenPWIconImage : ShowPWIconImage} alt="show password button" />
                        </button>
                    }
                </div>
                {capslock &&
                    <img className="CapsLockImg" src={CapsLockIconImage} alt="capslock icon" />
                }
            </div>
        </fieldset>
    );
}

export default CommonInput;